import { useState } from "react";
import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import {
  DesktopWindowsOutlined,
  PeopleOutline,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import { formatNumber } from "./utils";

const useStyles = makeStyles({
  card: {
    backgroundColor: themeColorsDesingSystem.background.main,
    borderRadius: 4,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: `1px solid ${themeColorsDesingSystem.stone.main}`,
    padding: "1.5rem",
    height: "100%",
  },
  title: {
    fontSize: "0.875rem",
    fontWeight: 700,
    color: themeColorsDesingSystem.gray.dark,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    marginBottom: "0.25rem",
  },
  value: {
    fontSize: "2rem",
    fontWeight: 400,
    color: themeColorsDesingSystem.text.primary,
    lineHeight: 1.2,
  },
  trend: {
    fontSize: "0.6875rem",
    marginTop: "0.5rem",
    fontWeight: 600,
  },
  trendPositive: {
    color: themeColorsDesingSystem.green.main,
  },
  trendNegative: {
    color: themeColorsDesingSystem.red.main,
  },
  iconWrapper: {
    width: 48,
    height: 48,
    borderRadius: "50%",
    backgroundColor: themeColorsDesingSystem.primary.main,
    color: themeColorsDesingSystem.background.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(19,41,75,0.25)",
    flexShrink: 0,
  },
  expandButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    cursor: "pointer",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: themeColorsDesingSystem.gray.main,
    marginTop: "1.25rem",
    paddingTop: "1rem",
    border: "none",
    borderTop: `1px solid ${themeColorsDesingSystem.stone.light}`,
    background: "none",
    fontFamily: "inherit",
    "&:hover": {
      color: themeColorsDesingSystem.text.primary,
    },
  },
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "0.8125rem",
    marginTop: "0.5rem",
  },
});

function SummaryCard({
  title,
  value,
  icon,
  trend,
  trendPositive,
  detalhesPerfil,
  disableTrend,
}) {
  const classes = useStyles();
  const [expandido, setExpandido] = useState(false);

  return (
    <Box className={classes.card}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.value}>{value ?? "-"}</Typography>
          {trend && !disableTrend && (
            <Typography
              className={`${classes.trend} ${
                trendPositive ? classes.trendPositive : classes.trendNegative
              }`}
            >
              {trend}
            </Typography>
          )}
        </Box>
        <Box className={classes.iconWrapper}>{icon}</Box>
      </Box>

      {detalhesPerfil?.length > 0 && (
        <Box>
          <button
            type="button"
            className={classes.expandButton}
            onClick={() => setExpandido(!expandido)}
          >
            <span>Detalhes por perfil</span>
            {expandido ? (
              <ExpandLess fontSize="small" />
            ) : (
              <ExpandMore fontSize="small" />
            )}
          </button>
          {expandido &&
            detalhesPerfil.map((item, idx) => (
              <Box key={idx} className={classes.detailRow}>
                <span style={{ color: themeColorsDesingSystem.gray.main }}>
                  {item.perfil}
                </span>
                <span style={{ fontWeight: 700 }}>{item.qtd}</span>
              </Box>
            ))}
        </Box>
      )}
    </Box>
  );
}

function mapPerfilDetalhes(items) {
  if (!items?.length) {
    return [];
  }

  return items.map((item) => ({
    perfil: item.Perfil,
    qtd: formatNumber(item.Quantidade),
  }));
}

export default function SummaryCards({ data, isMobile }) {
  const itemSize = isMobile ? 12 : 6;

  return (
    <Grid container spacing={3} style={{ marginBottom: "1.5rem" }}>
      <Grid item xs={itemSize}>
        <SummaryCard
          title="Telas Acessadas"
          value={formatNumber(data?.QuantidadeAcesso)}
          icon={<DesktopWindowsOutlined />}
          trend={data?.TendenciaAcessos}
          trendPositive={data?.TendenciaAcessosPositiva}
          detalhesPerfil={mapPerfilDetalhes(data?.DetalhesPerfilAcessos)}
          disableTrend={true}
        />
      </Grid>
      <Grid item xs={itemSize}>
        <SummaryCard
          title="Usuários Ativos"
          value={formatNumber(data?.QuantidadeUsuarioAtivo)}
          icon={<PeopleOutline />}
          trend={data?.TendenciaUsuarios}
          trendPositive={data?.TendenciaUsuariosPositiva}
          detalhesPerfil={mapPerfilDetalhes(data?.DetalhesPerfilUsuarios)}
          disableTrend={true}
        />
      </Grid>
    </Grid>
  );
}
